import { render, staticRenderFns } from "./CopyPartition.vue?vue&type=template&id=6116a113"
import script from "./CopyPartition.vue?vue&type=script&lang=js"
export * from "./CopyPartition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports